module.exports = __webpack_public_path__ + "media/images/cureus_logo_2014_white_mobile-706367541ecf0ce5dacd49721744aae3.png";